import {
  ActionReducer,
  ActionReducerMap,
  MetaReducer,
  StoreModule
} from "@ngrx/store";

import { ActiveFormReducer } from "./activeForm";
import { AppConfigReducer } from "./app";
import { AppState } from "./app-state.interface";
import { AuthReducer } from "./auth";
import { ModuleWithProviders } from "@angular/core";
import { ProjectsReducer } from './projects';
import { ProjectsReducer as ProjectsV2Reducer } from './v2/projects/projects.reducer';
import { UserReducer } from "./user";
import { localStorageSync } from "ngrx-store-localstorage";

export const reducers: ActionReducerMap<AppState> = {
  users: UserReducer,
  auth: AuthReducer,
  app: AppConfigReducer,
  activeForm: ActiveFormReducer,
  projects: ProjectsReducer,
  projects_v2: ProjectsV2Reducer
  // forms or projects
};

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({ keys: ["auth", "projects_v2"], rehydrate: true })(reducer);
}

const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

export const AppStateModule: ModuleWithProviders = StoreModule.forRoot(
  reducers,
  {
    metaReducers
  }
);



// WEBPACK FOOTER //
// ./src/states/app-state.module.ts